import { Routes } from "@angular/router";
import { RoutesConstant } from "./constant/routes-constant";
import { provideEffects } from "@ngrx/effects";
import { provideState } from "@ngrx/store";
import { initGuard } from "./guards/init/init-guard";
import { FetchAiAgentReducer } from "./common/stores/ai-agents/fetch-ai-agent/fetch.reducer";
import { FetchAIAgentEffects } from "./common/stores/ai-agents/fetch-ai-agent/fetch.effects";
import { EditAiAgentReducer } from "./common/stores/ai-agents/edit-ai-agent/edit.reducer";
import { EditAiAgentEffects } from "./common/stores/ai-agents/edit-ai-agent/edit.effects";
import { FetchUsersReducer } from "./common/stores/control-center/user-management/fetch-user/fetch-user.reducer";
import { FetchUsersEffects } from "./common/stores/control-center/user-management/fetch-user/fetch-user.effects";
import { CopyLanguageEffects } from "./common/stores/manage-languages/copy-language/copy-language.effects";
import { copyLanguageReducer } from "./common/stores/manage-languages/copy-language/copy-language.reducers";
import {
  fetchBotDetailsEffect,
  fetchSDKEffect,
  generateJwtTokenEffect,
  getBotDetailsReducers,
  GET_BOT_DETAILS_FEATURE_KEY,
  getJwtTokenReducers,
  GET_JWT_TOKEN_FEATURE_KEY,
  getSdkSettingsReducers,
  GET_SDK_SETTINGS_FEATURE_KEY,
} from "shared-ui";

export const routes: Routes = [
  // BEFORE LOGIN WRAPPER AROUND
  {
    path: "",
    loadComponent: () =>
      import("./common/auth-feature/auth-wrapper/auth-wrapper.component").then(
        (comp) => comp.AuthWrapperComponent,
      ),
    loadChildren: () =>
      import("./common/auth-feature/auth.routes").then((m) => m.authRoutes),
  },
  // AFTER SELECTING BOT, MAIN CONTENT WRAPPER AROUND
  {
    path: RoutesConstant.MainPath,
    loadComponent: () =>
      import("./common/main-content-wrapper/main-content-wrapper.component").then(
        (comp) => comp.MainContentWrapperComponent,
      ),
    loadChildren: () =>
      import("./components/main.routes").then((m) => m.routes),
    canActivate: [initGuard],
    providers: [
      provideState("editAiAgents", EditAiAgentReducer),
      provideEffects([EditAiAgentEffects]),

      provideState("fetchAiAgent", FetchAiAgentReducer),
      provideEffects([FetchAIAgentEffects]),

      provideState("fetchUsers", FetchUsersReducer),
      provideEffects([FetchUsersEffects]),

      provideState("copyLanguage", copyLanguageReducer),
      provideEffects([CopyLanguageEffects]),

      provideState(GET_SDK_SETTINGS_FEATURE_KEY, getSdkSettingsReducers),
      provideEffects(fetchSDKEffect),

      provideState(GET_BOT_DETAILS_FEATURE_KEY, getBotDetailsReducers),
      provideEffects(fetchBotDetailsEffect),

      provideState(GET_JWT_TOKEN_FEATURE_KEY, getJwtTokenReducers),
      provideEffects(generateJwtTokenEffect),
    ],
  },
];
